import script from "./RecommendSearchMod.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendSearchMod.vue?vue&type=script&setup=true&lang=js"

import "./RecommendSearchMod.vue?vue&type=style&index=0&id=9962f75a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9962f75a"]])

export default __exports__